import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-confirm-warning',
  templateUrl: './icon-confirm-warning.component.html',
  styles: []
})
export class IconConfirmWarningComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
